module.exports = __webpack_public_path__ + "media/components/country-flag/static/vn-3f9c906084b07ac0dd5820bc68c4bcbf.svg";